module.exports = __webpack_public_path__ + "media/images/blog/blog_slide_03-f6c72d95cc1b1e428f5f557b5b3b419c.jpg";